import { apiClient } from '../client'
import type { AuthLoginResponse, AuthSession, DevLoginRequest } from '../types/auth'

export async function devLogin(payload: DevLoginRequest): Promise<AuthLoginResponse> {
  return apiClient.post<AuthLoginResponse>('/api/auth/dev-login', payload)
}

export async function getCurrentSession(): Promise<AuthSession> {
  return apiClient.get<AuthSession>('/api/auth/me')
}
